import { AnswerMode } from './AnswerMode';

/**
 * Class representing a plus-minus answer mode.
 * @extends AnswerMode
 */
export class PlusMinusAnswerMode extends AnswerMode {}
